<template>
  <svg class="logo" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  	   width="80px" height="70px" viewBox="73.385 63.129 80 70">
    <path d="M113.385,64.129l-40,20.138l40,20.138l40-20.138L113.385,64.129z M86.185,84.267l27.2-13.694l27.2,13.694
    l-27.2,13.692L86.185,84.267z"/>
    <polygon points="113.385,111.316 80.457,94.739 73.385,98.299 113.385,118.436 153.385,98.299 146.313,94.739 	"/>
    <polygon points="113.385,125.009 80.457,108.432 73.385,111.993 113.385,132.129 153.385,111.993 146.313,108.432
    "/>
  </svg>
</template>

<script>
export default {
  name: 'logo',
};
</script>

<style lang="scss" scoped>
svg {
  fill: currentcolor;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// Logo.vue?e8c73ea4